import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import { Link } from 'react-router-dom';

export default function HotRecommendations() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-3">
          <div>
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
              热门推荐
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              大家都在看
            </h2>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            更多热门
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}